import React, { useState, useEffect } from "react";
import { Div, Text } from "atomize";
import { graphql } from "gatsby";
import Layout from "../components/common/layout";
import Header from "../components/common/Header";
import PodcastHero from "../components/podcasts/PodcastHero";
import PodcastsList from "../components/podcasts/PodcastsList";
import PodcastHosts from "../components/podcasts/PodcastHosts";
import PodcastDiscord from "../components/podcasts/PodcastDiscord";
import PodcastSubmitApplication from "../components/podcasts/PodcastSubmitApplication";
import Footer from "../components/common/Footer";

const Podcast = ({ data }) => {
  const [isTransparent, setIsTransparent] = useState(true);

  //get podcasts data from stories
  //   const podcasts = data.stories.edges;
  var podcasts = data.stories.edges.filter(podcast => {
    return podcast.node.categories.data.find(name => {
      return name.name === "Podcast";
    });
  });

  const handleScroll = () => {
    const height = 100;
    if (window.pageYOffset >= height) {
      setIsTransparent(false);
    } else {
      setIsTransparent(true);
    }
  };

  useEffect(() => {
    document.addEventListener("scroll", handleScroll);
  });

  return (
    <>
      <Layout>
        {/* <SEO seo={page.seo} url="https://trend.io/podcast" /> */}
        <Header
          headerFixed={true}
          isTransparent={isTransparent}
          data={{ contentfulJson: data.headerJson }}
        />
        <Div m={{ t: { xs: "-57px", lg: "-60px" }, b: "4.875rem" }}>
          <PodcastHero />
        </Div>
        <Div>
          <PodcastsList
            text="Most Recent Episodes"
            category="podcasts"
            data={podcasts.slice(0, 3)}
          />
        </Div>
        <Div m={{ t: { xs: "6.625rem", md: "4.75rem" } }}>
          <PodcastDiscord />
        </Div>
        <Div m={{ t: { xs: "6.5rem", md: "12.875rem" } }}>
          <PodcastHosts />
        </Div>
        <Div m={{ t: "7.75rem", b: "7.125rem" }}>
          <PodcastSubmitApplication />
        </Div>
        <Div>
          <PodcastsList
            text="All Episodes"
            category="podcasts"
            data={podcasts}
          />
        </Div>
        <Footer
          contentfulFooter={data.contentfulFooter}
          contentfulGlobalConfig={data.contentfulGlobalConfig}
        />
      </Layout>
    </>
  );
};

export const query = graphql`
  query PodcastPage {
    contentfulFooter(contentful_id: { eq: "5noUnCCOBDl8Is2Ppw2Nty" }) {
      solutions {
        label
        link
        isExternal
      }
      menu {
        label
        link
        isExternal
      }
      links {
        label
        link
        isExternal
      }
      instagramLink
      logoLink
    }

    contentfulGlobalConfig {
      footerForm {
        footerForm
      }
    }

    headerJson: contentfulJson(
      contentful_id: { eq: "2NCeKxLHd9JagUBAEsXDMo" }
    ) {
      json {
        json
      }
    }

    stories: allStoryChief(sort: { fields: [published_at], order: DESC }) {
      edges {
        node {
          __typename
          id
          title
          published_at
          featured_image {
            data {
              name
              url
            }
          }
          excerpt
          categories {
            data {
              name
            }
          }
          custom_fields {
            data {
              key
              name
              value
            }
          }
          slug
        }
      }
    }
  }
`;

export default Podcast;
